import { Button } from '@/components/ui/button'

const EmptyChat = ({ createChat, name }) => (
  <div className='flex-1 flex flex-col justify-center items-center text-center w-full h-full p-4'>
    <div className="text-6xl mb-6 block" aria-label="Waving hand and Robot face">
      <span role="img" aria-label="Waving hand" className="inline-block origin-[70%_70%] [animation:var(--animate-wave)]">👋</span>
      <span role="img" aria-label="Robot face" className="inline-block ml-2 [animation:var(--animate-robot-pulse)]">🤖</span>
    </div>
    <p className='text-xl font-semibold mb-2'>No chats yet</p>
    <p className='text-base text-gray-600 max-w-md mb-6'>
      Start a new chat with <strong>{name}</strong> by clicking the button below.
    </p>
    <Button
      className='mt-3 animate-button-pulse'
      onClick={() => createChat()}
    >
      Start Chat
    </Button>
  </div>
)

export default EmptyChat
